import React from 'react'
import LoginPage from '../components/pageComponents/LoginPage/LoginPage'
import HomePage from '../components/pageComponents/HomePage/HomePage'
import UsersPage from '../components/pageComponents/UsersPage'
import SignupPage from '../components/pageComponents/SignUpPage'
import CreatePostPage from '../components/pageComponents/CreatePostPage/CreatePostPage'
import UpdatePostPage from '../components/pageComponents/UpdatePostPage'
import ViewPostPage from '../components/pageComponents/ViewPostPage/ViewPostPage'
import CommunityPage from '../components/pageComponents/CommunityPage/CommunityPage'
import ViewNotificationPage from '../components/pageComponents/ViewNotificationPage'
import ViewProfilePage from '../components/pageComponents/ViewProfilePage/ViewProfilePage'
import ReportedPostsPage from '../components/pageComponents/ReportedPostsPage'
import ReportedCommentsPage from '../components/pageComponents/ReportedCommentsPage'
import ResetPasswordPage from '../components/ResetPasswordPage'
import SettingsPage from '../components/pageComponents/SettingsPage/SettingsPage'
import UpdateEmailAddressPage from '../components/UpdateEmailAddressPage'
import { Navigate } from 'react-router-dom'

const routes = [
  { path: '/', element: <Navigate to='/home' replace /> },
  { path: '/login', element: <LoginPage/> },
  { path: '/home', element: <HomePage/> },
  { path: '/users', element: <UsersPage/> },
  { path: '/reported-posts', element: <ReportedPostsPage/> },
  { path: '/reported-comments', element: <ReportedCommentsPage/> },
  { path: '/reset-password/:uuid', element: <ResetPasswordPage/> },
  { path: '/settings', element: <SettingsPage/> },
  { path: '/signup', element: <SignupPage/> },
  { path: '/create-post/:communityId?', element: <CreatePostPage/> },
  { path: '/update-post/:postId', element: <UpdatePostPage/> },
  { path: '/update-email-address/:uuid', element: <UpdateEmailAddressPage/> },
  { path: '/view-post/:postId', element: <ViewPostPage/> },
  { path: '/view-notifications', element: <ViewNotificationPage/> },
  { path: '/view-profile', element: <ViewProfilePage/> },
  { path: '/communities/:communityId', element: <CommunityPage/> }
]

export default routes
